import moment from 'moment'

export function normalizeSort (sortByList, sortDescList) {
  let result = ''

  sortDescList.forEach((item, index) => {
    result += (item ? ('-' + sortByList[index]) : sortByList[index]) + ','
  })

  return result.replace(/,\s*$/, '')
}

export function sortDateRange (range) {
  let firstParam = range[0]
  let secondParam = range[1]
  return (firstParam > secondParam ? [secondParam, firstParam] : [firstParam, secondParam])
}

export function formatDateRange (range) {
  return [moment(range[0]).locale('es').format('L'), moment(range[1]).locale('es').format('L')]
}

export function formatDate (range) {
  return [moment(range).locale('es').format('DD/MM/YYYY')]
}

export function formatDatePicker (range) {
  return [moment(range).locale('es').format('YYYY-MM-DD')]
}

export function formatDatePeriod (periodo) {
  if (!periodo.includes('/') || !periodo.includes(' ')) {
    return ''
  } else {
    const $date = periodo.split(' ')[0].split('/')
    return $date[2] + '-' + $date[1] + '-' + $date[0]
  }
}

export function getUTCFromDate (date) {
  return Date.parse(date)
}

// TODO Eliminar esto
export function formatDateTimeRange (range, time) {
  if (time.length >= 2) {
    return [moment(range[0] + ' ' + time[0] + ':00').locale('es').format('YYYY/MM/DD HH:mm'), moment(range[1] + ' ' + time[1] + ':00').locale('es').format('YYYY/MM/DD HH:mm')]
  } else {
    return [moment(range[0] + ' ' + time[0] + ':00').locale('es').format('YYYY/MM/DD HH:mm'), moment(range[1]).locale('es').format('L')]
  }
}

export function fullRange (range) {
  if (range.length === 2) {
    let sorted = sortDateRange(range)
    let init = sorted[0] + ' 00:00:00'
    let end = sorted[1] + ' 23:59:59'
    return [init, end].join(' ~ ')
  } else {
    return null
  }
}
export function isMobileOrTablet (vueInstance) {
  return vueInstance.$vuetify.breakpoint.mdAndDown
}

// TODO Eliminar esto
export function fullRangeTime (range, time) {
  if (Array.isArray(range) && range.length === 2) {
    let sorted = sortDateRange(range)
    let init = sorted[0] + ' 00:00:00'
    let end = sorted[1] + ' 23:59:59'
    if (Array.isArray(time) && time.length === 2) {
      init = sorted[0] + ' ' + time[0] + ':00'
      end = sorted[1] + ' ' + time[1] + ':00'
    }
    return [init, end].join(' ~ ')
  } else {
    return null
  }
}

/**
 * Verifica si un error es de tipo permiso (403)
 * @param {Error} error - El error capturado
 * @returns {boolean} true si es un error de permisos
 */
export function isPermissionError (error) {
  return error && error.isPermissionError === true
}

/**
 * Maneja errores de permisos mostrando un mensaje apropiado al usuario
 * @param {Error} error - El error capturado
 * @param {Object} vueInstance - Instancia de Vue para acceder a $toast
 * @param {string} defaultMessage - Mensaje por defecto si no hay mensaje específico
 */
export function handlePermissionError (error, vueInstance, defaultMessage = 'No tienes permisos para realizar esta acción.') {
  if (isPermissionError(error)) {
    const message = error.permissionMessage || defaultMessage
    vueInstance.$toast.warning(message)
    return true
  }
  return false
}

/**
 * Maneja errores generales con manejo específico para permisos
 * @param {Error} error - El error capturado
 * @param {Object} vueInstance - Instancia de Vue para acceder a $toast
 * @param {string} defaultErrorMessage - Mensaje por defecto para errores generales
 * @param {string} permissionMessage - Mensaje específico para errores de permisos
 */
export function handleApiError (error, vueInstance, defaultErrorMessage = 'Ha ocurrido un error.', permissionMessage = 'No tienes permisos para realizar esta acción.') {
  if (handlePermissionError(error, vueInstance, permissionMessage)) {
    return
  }

  // Para otros tipos de errores, mostrar mensaje genérico
  let message = defaultErrorMessage

  if (error.response) {
    const { status, data } = error.response

    switch (status) {
      case 400:
        message = data?.message || 'Datos inválidos.'
        break
      case 404:
        message = data?.message || 'Recurso no encontrado.'
        break
      case 422:
        message = data?.message || 'Error de validación.'
        break
      case 500:
        message = 'Error interno del servidor. Inténtalo de nuevo más tarde.'
        break
      default:
        message = data?.message || defaultErrorMessage
        break
    }
  } else if (error.request) {
    message = 'Error de conexión. Verifica tu conexión a internet.'
  }

  vueInstance.$toast.error(message)
}

// Texto de una ubicación en los selectores: "Nombre (Dealer)".
// Prioridad del dealer que etiqueta:
//   1) el dealer del usuario, si la ubicación está asignada (propia o compartida);
//   2) el dealer preferido (holder del vehículo en el contexto de un movimiento del
//      colaborador), si la ubicación está entre sus dealers compartidos; esto lo
//      resuelve el backend en `effective_dealer_name` cuando se pide con
//      filter[vehicle_id], y aquí se usa como preferencia por encima del principal;
//   3) el dealer principal / dealer_name.
export function locationDisplayName (location, ownDealer, preferredDealer = null) {
  const assignedToMe = location.is_own === true ||
    (!!ownDealer && Array.isArray(location.dealers) && location.dealers.some(d => d.id === ownDealer.id))
  if (assignedToMe && ownDealer && ownDealer.name) {
    return `${location.name} (${ownDealer.name})`
  }
  if (preferredDealer && preferredDealer.id && Array.isArray(location.dealers)) {
    const match = location.dealers.find(d => d.id === preferredDealer.id)
    if (match) {
      return `${location.name} (${match.name || preferredDealer.name})`
    }
  }
  const dealerName = location.effective_dealer_name
    || (location.dealer && location.dealer.name)
    || location.dealer_name
  return dealerName ? `${location.name} (${dealerName})` : location.name
}
